import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import { mapState } from "vuex";

export default {
    beforeMount() {
        this.$store.dispatch('adminAppAdvertisements/fetchAdvertisementData', {
            'advertisementId': this.$route.params.advertisementId,
        });
    },
    components: {
        top,
        navigation,
        bottom
    },
    computed: {
        ...mapState('adminAppAdvertisements', {
            editAdvertisementLoaded: state => state.editAdvertisementLoaded,
        }),
        avatar: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.avatar;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'avatar',
                    fieldToEditValue: value,
                });
            }
        },
        title: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.title;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'title',
                    fieldToEditValue: value,
                });
            }
        },
        link: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.link;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'link',
                    fieldToEditValue: value,
                });
            }
        },
        limitClicks: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.limit_clicks;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'limit_clicks',
                    fieldToEditValue: value,
                });
            }
        },
        limitViews: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.limit_views;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'limit_views',
                    fieldToEditValue: value,
                });
            }
        },
        language: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.language;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'language',
                    fieldToEditValue: value,
                });
            }
        },
        content: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.content;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'content',
                    fieldToEditValue: value,
                });
            }
        },
        isActive: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.is_active;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'is_active',
                    fieldToEditValue: value,
                });
            }
        },
        isForMobile: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.is_for_mobile;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'is_for_mobile',
                    fieldToEditValue: value,
                });
            }
        },
        isForWeb: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.is_for_web;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'is_for_web',
                    fieldToEditValue: value,
                });
            }
        },
        isClickable: {
            get() {
                return this.$store.state.adminAppAdvertisements.editAdvertisement.is_clickable;
            },
            set(value) {
                this.$store.commit("adminAppAdvertisements/setEditAdvertisementField", {
                    fieldToEdit: 'is_clickable',
                    fieldToEditValue: value,
                });
            }
        },
    },
    methods: {
        updateAdvertisement(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppAdvertisements/editAdvertisement');
        },
        deleteAdvertisement(evt) {
            evt.preventDefault();
            this.$store.dispatch('adminAppAdvertisements/deleteAdvertisement');
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-edit-advertisement/master/app-edit-advertisement.js